let HomePage = resolve => require(['@/views/home/Index.vue'], resolve)
const routes = [{
    path: '/',
    component: HomePage,
    name: 'homePage',
    meta: {
        title: '首页'
    },
}];

export default routes